import React, { forwardRef } from 'react';
import { Typography } from '../../../atoms/typography/Typography';
import { Stack } from '../../../atoms/stack/Stack';
import { CompareItem } from '../../../molecules/shared/compareItem/CompareItem';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';

const CompareSystems = forwardRef(({ section }, ref) => {
  const halfLength = Math.ceil(section.componentData.length / 2);
  const firstHalf = section.componentData.slice(0, halfLength);
  const secondHalf = section.componentData.slice(halfLength);

  return (
    <div ref={ref} className="bg-primary-50">
      <div className="flex w-full flex-col flex-1 px-8 lg:mx-auto py-10 md:py-20 max-w-6xl">
        <div className="flex flex-col flex-1 gap-20 py-5 items-center">
          <Typography as="h4" fontVariant="h4">
            {section.title}
          </Typography>
          <div className="flex flex-col md:flex-row flex-1 w-full gap-4 md:gap-10 justify-between items-center">
            <Stack className="gap-4 flex-1 w-full items-center md:items-start">
              {firstHalf.map((data) => (
                <CompareItem
                  key={data.id}
                  logoOneUrl={data.systems[0].logoUrl}
                  logoTwoUrl={data.systems[1].logoUrl}
                  logoOneAlt={data.systems[0].name}
                  logoTwoAlt={data.systems[1].name}
                  compareUrl={data.compareUrl}
                />
              ))}
            </Stack>
            <Stack className="gap-4 flex-1 w-full items-center md:items-end">
              {secondHalf.map((data) => (
                <CompareItem
                  key={data.id}
                  logoOneUrl={data.systems[0].logoUrl}
                  logoTwoUrl={data.systems[1].logoUrl}
                  logoOneAlt={data.systems[0].name}
                  logoTwoAlt={data.systems[1].name}
                  compareUrl={data.compareUrl}
                />
              ))}
            </Stack>
          </div>
          {/* <LinkButton
            textTransform="uppercase"
            label={section.buttonText}
            href={section.buttonHref}
            external
            trackingFn={() => {
              trackOutboundLink(
                {},
                extraBtnLink,
                category,
                'system-page-top',
                systemId,
                {
                  page_type: 'System page',
                  system_name: title,
                  result_position: 'top',
                }
              );
            }}
            size="lg"
          /> */}
        </div>
      </div>
    </div>
  );
});

export default CompareSystems;
